import React, { FC } from 'react';

import useTabs, { TabItemId } from 'Src/components/navigation/useTabs';

interface TabContentProps {
  value: TabItemId | TabItemId[];
}

const TabContent: FC<React.PropsWithChildren<TabContentProps>> = ({ value, children }) => {
  const { store: tabs } = useTabs();
  const values = Array.isArray(value) ? value : [value];

  return values.includes(tabs.selected)
    ? children
    : undefined;
};

export default TabContent;
export type { TabContentProps };
